import { makeStyles } from '@material-ui/core/styles'

const useMenuListStyles = makeStyles(({
    root: {
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        alignItems: 'flex-start',
        padding: '0rem 0rem 0.5rem 0rem !important',
        maxHeight:'29rem',
        '& .MuiMenu-paper':{
            maxHeight:'none',
            '& .MuiList-root': {
                maxWidth:'100% !important',
            }
        }
    },
    containerButtons:{
        position: 'sticky',
        bottom: '0',
        backgroundColor: 'white',
        paddingTop: '0.813rem',
        paddingBottom: '1rem',
        display:'flex',
        justifyContent:'flex-end'
    }
}), { name: 'MuiList' });

export default useMenuListStyles
